// extracted by mini-css-extract-plugin
export var card = "_6x-0";
export var failedIcon = "_6x-4";
export var failedIconBadge = "_6x-3";
export var icon = "_6x-1";
export var successIcon = "_6x-2";